module.exports = __webpack_public_path__ + "static/img/map5.df6f59b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map5.jpg
// module id = iZih
// module chunks = 1